// components/Modal.tsx
import React from "react";
import styles from "./Modal.module.css";

interface ModalProps {
  title?: string;
  content: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ title, content, onClose }) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()} // prevent overlay close on modal click
      >
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>
        {title && <h2 className={styles.title}>{title}</h2>}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default Modal;
